import { render } from "./PathwayMappingTemplateEditor.vue?vue&type=template&id=c73b9554"
import script from "./PathwayMappingTemplateEditor.vue?vue&type=script&lang=js"
export * from "./PathwayMappingTemplateEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/PathwayMappingTemplateEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c73b9554"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c73b9554', __exports__)) {
    api.reload('c73b9554', __exports__)
  }
  
  module.hot.accept("./PathwayMappingTemplateEditor.vue?vue&type=template&id=c73b9554", () => {
    api.rerender('c73b9554', render)
  })

}


export default __exports__